import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, checking } = useAuth();
  if (checking || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FBF9F5]">
        <div className="text-[#B87333] font-serif text-xl animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to={adminOnly ? "/admin/login" : "/login"} replace />;
  if (adminOnly && !["owner", "admin", "staff"].includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}
